/* RESPONSIBLE TEAM: team-phone */

export type FinVoiceRunbookOptions = {
  value: FinVoiceRunbook;
  text: string;
};

export type FinVoiceRunbook =
  | 'none'
  | 'general_faq'
  | 'card_reader_troubleshooting'
  | 'caller_identification_workflow'
  | 'flex_terminal_card_reader'
  | 'damaged_card_reader'
  | 'identify_device_models'
  | 'insert_only_flex_terminal'
  | 'nfc_only_flex_terminal'
  | 'swipe_only_flex_terminal'
  | 'elo_terminal_card_reader_issue'
  | 'insert_only_elo_terminal'
  | 'swipe_only_elo_terminal'
  | 'network_offline'
  | 'nfc_only_elo_terminal'
  | 'dual_card_reader_setup_not_working_flex_terminal'
  | 'dual_card_reader_setup_not_working_elo_terminal'
  | 'all_functions_not_working_elo_terminal'
  | 'all_functions_not_working_flex_terminal'
  | 'elo_dynamag_msr_not_working'
  | 'card_reader_not_working_general_troubleshooting';

export interface FinVoiceRunbookGroup {
  heading?: string;
  items: FinVoiceRunbookOptions[];
}

export const FIN_VOICE_RUNBOOK_GROUPED_OPTIONS: FinVoiceRunbookGroup[] = [
  // Priority options (no heading)
  {
    items: [
      { value: 'none', text: 'ai-agent.voice-playground.settings.runbook-none' },
      {
        value: 'general_faq',
        text: 'ai-agent.voice-playground.settings.runbook-general-faq',
      },
      {
        value: 'card_reader_not_working_general_troubleshooting',
        text: 'ai-agent.voice-playground.settings.runbook-card-reader-not-working-general-troubleshooting',
      },
      {
        value: 'caller_identification_workflow',
        text: 'ai-agent.voice-playground.settings.runbook-caller-identification-workflow',
      },
    ],
  },
  // Card Reader Issues
  {
    heading: 'ai-agent.voice-playground.settings.runbook-group-card-reader',
    items: [
      {
        value: 'damaged_card_reader',
        text: 'ai-agent.voice-playground.settings.runbook-damaged-card-reader',
      },
      {
        value: 'identify_device_models',
        text: 'ai-agent.voice-playground.settings.runbook-identify-device-models',
      },
      {
        value: 'card_reader_troubleshooting',
        text: 'ai-agent.voice-playground.settings.runbook-card-reader-troubleshooting',
      },
      {
        value: 'all_functions_not_working_flex_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-all-functions-not-working-flex-terminal',
      },
      {
        value: 'insert_only_flex_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-insert-only-flex-terminal',
      },
      {
        value: 'swipe_only_flex_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-swipe-only-flex-terminal',
      },
      {
        value: 'nfc_only_flex_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-nfc-only-flex-terminal',
      },
      {
        value: 'flex_terminal_card_reader',
        text: 'ai-agent.voice-playground.settings.runbook-flex-terminal-card-reader',
      },
      {
        value: 'dual_card_reader_setup_not_working_flex_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-dual-card-reader-setup-not-working-flex-terminal',
      },
      {
        value: 'all_functions_not_working_elo_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-all-functions-not-working-elo-terminal',
      },
      {
        value: 'swipe_only_elo_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-swipe-only-elo-terminal',
      },
      {
        value: 'insert_only_elo_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-insert-only-elo-terminal',
      },
      {
        value: 'nfc_only_elo_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-nfc-only-elo-terminal',
      },
      {
        value: 'elo_terminal_card_reader_issue',
        text: 'ai-agent.voice-playground.settings.runbook-elo-terminal-card-reader-issue',
      },
      {
        value: 'dual_card_reader_setup_not_working_elo_terminal',
        text: 'ai-agent.voice-playground.settings.runbook-dual-card-reader-setup-not-working-elo-terminal',
      },
      {
        value: 'elo_dynamag_msr_not_working',
        text: 'ai-agent.voice-playground.settings.runbook-elo-dynamag-msr-not-working',
      },
    ],
  },
  // Networking
  {
    heading: 'ai-agent.voice-playground.settings.runbook-group-networking',
    items: [
      {
        value: 'network_offline',
        text: 'ai-agent.voice-playground.settings.runbook-network-offline',
      },
    ],
  },
];
